import { FC, CSSProperties } from 'react';
import styles from './Input.module.scss';
import { Icon, IconName } from '../Icon';
import { FieldInputProps } from 'react-final-form';

export interface IInputProps {
  label: string;
  placeholder?: string;
  icon?: IconName;
  customHeight?: number;
  customWidth?: number;
  type?: string;
  className?: string;
  inputClassName?: string;
  name?: string;
  style?: CSSProperties;
  statusField?: 'valid' | 'error' | 'default';
  value?: string;
  props?: FieldInputProps<any, HTMLElement>;
  autoFocus?: boolean;
  disabled?: boolean;
  isTextarea?: boolean;
  onChange?: (e: string) => void;
  onKeyDown?: (e: any) => void;
  onInput?: (e: any) => void;
  isFocused?: (focused: boolean) => void;
}

const Input: FC<IInputProps> = ({
  label,
  icon,
  placeholder,
  customHeight = 35,
  customWidth = '100%',
  type = 'text',
  className,
  inputClassName,
  style,
  name,
  props,
  statusField = 'default',
  value,
  autoFocus,
  disabled,
  isTextarea,
  onChange,
  onKeyDown,
  onInput, 
  isFocused,
}) => {
  const currentPlaceholder = placeholder ?? label;

  if (isTextarea) {
    return (
      <>
        <label className={`${styles['labelInput']} ${className ?? ''} `} style={style}>
          {icon ? <Icon icon={icon} color="cinzaIcone" /> : null}
          <textarea
            name={name}
            className={`${icon ? styles['paddingIcon'] : ''} ${
              statusField === 'default' ? '' : styles[statusField]
            } ${inputClassName ?? ''}`}
            type={type}
            autoFocus={autoFocus}
            value={value}
            placeholder={currentPlaceholder}
            style={{ height: customHeight, width: customWidth }}
            disabled={disabled}
            {...props}
            onKeyDown={onKeyDown}
            onFocus={() => isFocused && isFocused(true)}
            onBlur={() => isFocused && isFocused(false)}
            onInput={(e: any) => onInput && onInput(e.target.value)}
          />
          <span>{label}</span>
        </label>
      </>
    );
  }

  return (
    <>
      <label className={`${styles['labelInput']} ${className ?? ''} `} style={style}>
        {icon ? <Icon icon={icon} color="cinzaIcone" /> : null}
        <input
          name={name}
          className={`${icon ? styles['paddingIcon'] : ''} ${
            statusField === 'default' ? '' : styles[statusField]
          } ${inputClassName ?? ''}`}
          type={type}
          autoFocus={autoFocus}
          value={value}
          placeholder={currentPlaceholder}
          style={{ height: customHeight, width: customWidth }}
          disabled={disabled}
          {...props}
          onKeyDown={onKeyDown}
          onFocus={() => isFocused && isFocused(true)}
          onBlur={() => isFocused && isFocused(false)}
          onInput={(e: any) => onInput && onInput(e.target.value)}
        />
        <span>{label}</span>
      </label>
    </>
  );
};

export default Input;
